import React from "react";
import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { SITE_CONFIG } from "../../constants/config";

export default function WhatsAppFloat() {
    const whatsappLink = `${SITE_CONFIG.whatsappUrl}?text=${encodeURIComponent(SITE_CONFIG.whatsappMessage)}`;

    return (
        <motion.a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-gradient-brand flex items-center justify-center shadow-glow-purple-md hover:shadow-glow-purple-lg hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50 transition-all duration-300 group"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 1, type: "spring", stiffness: 200, damping: 15 }}
            aria-label="Chat on WhatsApp"
        >
            <FaWhatsapp size={28} className="text-white" />

            {/* Pulse effect */}
            <span className="absolute inset-0 rounded-full bg-brand-500 animate-ping opacity-25" />

            {/* Tooltip */}
            <span className="absolute right-full mr-3 px-3 py-1.5 rounded-lg bg-surface-elevated text-white text-body-xs font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none border border-white/[0.06]">
                Chat with us
            </span>
        </motion.a>
    );
}
